var RG_TYPE;
(function (RG_TYPE) {
    RG_TYPE["World"] = "World";
    RG_TYPE["Site"] = "Site";
    RG_TYPE["Zone"] = "Zone";
    RG_TYPE["Plot"] = "Plot";
    RG_TYPE["Building"] = "Building";
    RG_TYPE["Entrance"] = "Entrance";
    RG_TYPE["Core"] = "Core";
    RG_TYPE["Corridor"] = "Corridor";
    RG_TYPE["Apartment"] = "Apartment";
    RG_TYPE["Module"] = "Module";
    RG_TYPE["Balcony"] = "Balcony";
    RG_TYPE["Roof"] = "Roof";
    RG_TYPE["Wall"] = "Wall";
    RG_TYPE["Facade"] = "Facade";
    RG_TYPE["Floor"] = "Floor";
    RG_TYPE["Ceiling"] = "Ceiling";
    RG_TYPE["Column"] = "Column";
    RG_TYPE["Beam"] = "Beam";
    RG_TYPE["Window"] = "Window";
    RG_TYPE["Door"] = "Door";
    RG_TYPE["TechnicalSpace"] = "TechnicalSpace";
    RG_TYPE["TechnicalSpaceRoom"] = "TechnicalSpaceRoom";
    RG_TYPE["Room"] = "Room";
    RG_TYPE["Opening"] = "Opening";
    RG_TYPE["Parapet"] = "Parapet";
    RG_TYPE["EmptySpace"] = "EmptySpace";
    RG_TYPE["Glazing"] = "Glazing";
})(RG_TYPE || (RG_TYPE = {}));

export { RG_TYPE };
//# sourceMappingURL=rg-type.js.map
